import { Link, useLocation, Outlet } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { useAuth } from '@/hooks/useAuth'
import { Button } from '@/components/ui/button'
import { LayoutGrid, LogOut } from 'lucide-react'

export function CRMLayout() {
  const location = useLocation()
  const { signOut } = useAuth()

  return (
    <div className="flex min-h-screen flex-col">
      <header className="sticky top-0 z-40 flex h-14 items-center gap-4 border-b bg-card px-4">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground text-sm font-bold">
          A
        </div>
        <span className="text-lg font-bold">AsterPay CRM</span>
        <nav className="ml-6 flex items-center gap-1">
          <Link
            to="/"
            className={cn(
              'flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors',
              location.pathname === '/'
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
            )}
          >
            <LayoutGrid className="h-4 w-4" />
            Pipeline
          </Link>
        </nav>
        <div className="ml-auto">
          <Button variant="ghost" size="sm" className="gap-2" onClick={() => signOut()}>
            <LogOut className="h-4 w-4" />
            Sign out
          </Button>
        </div>
      </header>
      <main className="flex-1 p-6">
        <Outlet />
      </main>
      <footer className="border-t px-4 py-2 text-center text-xs text-muted-foreground">
        crm.asterpay.io
      </footer>
    </div>
  )
}
